import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { CloseIcon, ImageTypeIcon, PDFTypeIcon, ThreeDIcon, VideoTypeIcon } from "../Assets/iconshere";
import DynamicUploadBox from "./DynamicUploadBox";
import { useSelector } from "react-redux";
import axios from "axios";
import apiClient from "../apiClient";

const dynamicContent = {
  image: [],
  video: [],
  pdf: [],
  model: [],
};

const initialBtnState = {
  text: "Save",
  active: false,
};

const DynamicContentModal = ({ uuid, show, handleClose }) => {
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [activeType, setActiveType] = useState("image");
  const [content, setContent] = useState(dynamicContent);
  const [inProgress, setInProgress] = useState(0);
  const [canSave, setCanSave] = useState(true);
  const [saveBtnTxt, setSaveBtnTxt] = useState(initialBtnState);

  const getDynamicContentById = async () => {
    try {

      const data = await apiClient.get(`${configData.config.API_URL}/api/resource/environment/content/${uuid}`);

      // const { data } = await axios.get(`${configData.config.API_URL}/api/resource/environment/content/${uuid}`, {
      //   headers: {
      //     Authorization: `Bearer ${userData?.token}`,
      //     "Content-Type": "application/json",
      //   },
      // });

      let response = data.data;
      if (response) {
        setContent(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateItem = (type, index, item) => {
    var previousContent = { ...content };
    previousContent[type][index] = item;
    setContent(previousContent);
  };

  useEffect(() => {
    if (uuid) {
      getDynamicContentById();
    }
  }, [uuid]);

  const handleSaveFiles = async () => {
    try {
      let files = { dynamic: content };

      await apiClient.post(`${configData.config.API_URL}/api/resource/environment/update/content/${uuid}`, files);

      // await axios.post(`${configData.config.API_URL}/api/resource/environment/update/content/${uuid}`, files, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //     "Content-Type": "application/json",
      //   },
      // });

      getDynamicContentById();
      handleClose();
    } catch (error) {
      console.error("Error saving files:", error);
    }
  };

  const handleClickClose = () => {
    setContent(dynamicContent);
    handleClose();
  };

  var toSave = [...content.image, ...content.pdf, ...content.video].filter((e) => e.url == null);
  var contentLength =
    [...content.image, ...content.pdf, ...content.video, ...content.model].length === 0 ? false : true;

  return (
    <>
      <Modal
        className="platmodaltime launchplaymodal downloadlauncher"
        size="xl"
        centered
        show={show}
        onHide={handleClickClose}
      >
        <Modal.Header className="modalheader">
          Dynamic Content
          <span onClick={handleClickClose}>
            {" "}
            <CloseIcon />{" "}
          </span>
        </Modal.Header>
        <Modal.Body className="p-3">
          <div className="playmodalmain DC">
            <div className="playmodalright">
              <div className="row dynamicC">
                <div className="filetype mt-3">
                  <div className={activeType === "image" ? "selectparent active" : "selectparent"}>
                    <span className="fileitem" onClick={() => setActiveType("image")}>
                      <ImageTypeIcon />
                    </span>
                    <span>{content["image"].length} Frames</span>
                  </div>

                  <div className={activeType === "video" ? "selectparent active" : "selectparent"}>
                    <span className="fileitem" onClick={() => setActiveType("video")}>
                      <VideoTypeIcon />
                    </span>
                    <span>{content["video"].length} Frames</span>
                  </div>

                  <div className={activeType === "pdf" ? "selectparent active" : "selectparent"}>
                    <span className="fileitem" onClick={() => setActiveType("pdf")}>
                      <PDFTypeIcon />
                    </span>
                    <span>{content["pdf"].length} Frames </span>
                  </div>

                  <div className={activeType === "model" ? "selectparent active" : "selectparent"}>
                    <span className="fileitem" onClick={() => setActiveType("model")}>
                      <ThreeDIcon />
                    </span>
                    <span>{content["model"].length} Frames </span>
                  </div>
                </div>
              </div>
              <div className="row fordynamicparent">
                <div className="uploadinventory">
                  {content && content[activeType]?.length
                    ? content[activeType].map((item, index) => {
                      return (
                        <div key={index + 1}>
                          <DynamicUploadBox
                            userId={uuid}
                            canSave={canSave}
                            setCanSave={setCanSave}
                            fileType={activeType}
                            item={item}
                            updateItem={updateItem}
                            inProgress={inProgress}
                            setInProgress={setInProgress}
                            index={index}
                          />
                        </div>
                      );
                    })
                    : null}
                </div>
              </div>
            </div>
          </div>

          <div className="footerbtn text-end mt-0">
            <button type="button" className="btn btn-secondary" onClick={handleClickClose}>
              Cancel
            </button>

            {contentLength && userData.user.permissions.includes("METAVERSE.DYNAMIC.CONTENT") && (
              <button type="button" className="btn btn-primary" disabled={saveBtnTxt.active} onClick={handleSaveFiles}>
                {saveBtnTxt.text}
              </button>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DynamicContentModal;
